import React, { useState, type FC } from 'react'
import svgQuestion from '../assets/question.svg'
import svgCancel from '../assets/cancel.svg'

import Modal from './Modal'
import StructuredText from './StructuredText'
import {
  REDIRECT_ROUTE_ON_LEAVE_QUIZ,
  SHOW_QUIT,
  SHOW_TIMER,
  SHOW_TOOLTIP
} from '../configs'

interface IProps {
  tooltip: IQuiz['acf_fields']['tooltip']
  minutes: string
  seconds: string
  quizId: string
}

const Menu: FC<IProps> = ({ tooltip, minutes, seconds, quizId }) => {
  const [showTooltipModal, setShowTooltipModal] = useState(false)
  const [showLeaveModal, setShowLeaveModal] = useState(false)

  return (
    <div className='shrink-0 flex justify-end gap-3 items-center m-8 lg:gap-9'>
      {SHOW_TIMER && (
        <span className='hidden lg:block'>
          {minutes}m{seconds}s
        </span>
      )}
      {SHOW_TOOLTIP && (
        <>
          <img
            className='cursor-pointer w-6 h-auto lg:w-9'
            src={svgQuestion}
            onClick={() => {
              setShowTooltipModal(prev => !prev)
            }}
          />
          <Modal state={showTooltipModal}>
            <div className='flex justify-between items-center mb-10 w-full'>
              <h2 className='text-5xl'>
                {tooltip?.title?.normal ?? ''}{' '}
                <i>{tooltip?.title?.italic ?? ''}</i>
              </h2>
              <img
                src={svgCancel}
                className='w-5 h-5 lg:w-10 lg:h-10 cursor-pointer'
                onClick={() => {
                  setShowTooltipModal(false)
                }}
              />
            </div>
            <StructuredText className="wysiwyg" data={tooltip?.content ?? ''} />
          </Modal>
        </>
      )}
      {SHOW_QUIT && (
        <>
          <img
            className='cursor-pointer w-5 h-auto lg:w-8'
            src={svgCancel}
            onClick={() => {
              setShowLeaveModal(prev => !prev)
            }}
          />
          <Modal state={showLeaveModal}>
            <div className='flex justify-between items-center mb-10 w-full'>
              <h2 className='text-3xl'>Leave quiz</h2>
              <img
                src={svgCancel}
                className='w-5 h-5 lg:w-10 lg:h-10 cursor-pointer'
                onClick={() => {
                  setShowLeaveModal(false)
                }}
              />
            </div>
            <p className='mb-8'>Are you sure you want to leave ?</p>
            <div className='flex gap-4'>
              <button
                className='flex-1 bg-duskBlack text-pureWhite px-4 py-2'
                onClick={() => {
                  setShowLeaveModal(false)
                }}
              >
                No
              </button>
              <button
                className='flex-1 bg-duskBlack text-pureWhite p-4'
                onClick={() => {
                  window.location.replace(
                    REDIRECT_ROUTE_ON_LEAVE_QUIZ + '/?id=' + quizId
                  )
                }}
              >
                Yes
              </button>
            </div>
          </Modal>
        </>
      )}
    </div>
  )
}

export default Menu
